import React from "react";
import { motion } from "framer-motion";

const ProductFeatures=({
  subheading,
  heading,
  image,
  features,
})=>{

    const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },

    visible: {
      opacity: 1,
      y: 0,

      transition: {
        duration: 0.7,
      },
    },
  };

    return(
        <>
        <section className="product-features-section">

        <div className="container">

          {/* TOP */}

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.2,
            }}
            variants={{
              visible: {
                transition: {
                  staggerChildren: 0.12,
                },
              },
            }}
          >

            <motion.h3
              className="section-subheading"
              variants={fadeUp}
            >
             Features & Benefits
            </motion.h3>

            <motion.h2
              className="section-heading"
              variants={fadeUp}
            >
            Built for Performance. Designed for Reliability.
            </motion.h2>

          </motion.div>

          {/* GRID */}

          <div className="product-features-grid">

            {/* LEFT */}

            <motion.div
              className="product-features-left"
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                amount: 0.2,
              }}
              variants={{
                visible: {
                  transition: {
                    staggerChildren: 0.12,
                  },
                },
              }}
            >

              {features.map((item, i) => (

                <motion.div
                  className="product-features-card"
                  key={i}
                  variants={fadeUp}
                >

                  {/* ICON */}

                  <div className="product-features-icon">

                    <img
                      src={item.icon}
                      alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
                    />

                  </div>

                  {/* CONTENT */}

                  <div className="product-features-content">

                    <h4 className="card-heading">
                      {item.title}
                    </h4>

                    <p className="section-text">
                      {item.desc}
                    </p>

                  </div>

                </motion.div>

              ))}

            </motion.div>

            {/* RIGHT */}

            <motion.div
              className="product-features-right"
              initial={{
                opacity: 0,
                x: 80,
              }}
              whileInView={{
                opacity: 1,
                x: 0,
              }}
              transition={{
                duration: 0.9,
                ease: [0.22, 1, 0.36, 1],
              }}
              viewport={{
                once: true,
              }}
            >

              <img
                src={image}
                alt={`${heading} |Gurukrupa Wood Pvt. Ltd.`}
              />

            </motion.div>

          </div>

        </div>

      </section>
        </>
    )
}
export default ProductFeatures;